module.exports = __webpack_public_path__ + "static/bq-b1cb6ffa6a079e3644510a8e708d53ad.png";